// @flow
import * as React from 'react';
import classNames from 'classnames';
import isEqual from 'react-fast-compare';
import { Scrollbars } from 'react-custom-scrollbars';
import styles from './ScrollBar.module.scss';

type Props = {
    children: React.Node,
    className: string,
    maxHeight: number,
    showScrollBar: boolean,
};

export default class ScrollBar extends React.Component<Props> {
    static defaultProps = {
        className: '',
        maxHeight: 600,
        showScrollBar: true,
    };

    shouldComponentUpdate = (nextProps: Props) => !isEqual(this.props, nextProps);

    render() {
        const { className, maxHeight, showScrollBar } = this.props;

        const classes = classNames(styles.seeMoreItems, className);
        const trackClass = showScrollBar ? styles['scroll-track'] : styles['hide-scroll-track'];
        const thumbClass = showScrollBar ? styles['scroll-thumb'] : styles['hide-scroll-thumb'];
        return (
            <Scrollbars
                autoHeight
                autoHeightMax={maxHeight}
                hideTracksWhenNotNeeded
                renderView={props => <div {...props} className={classes} />}
                renderTrackVertical={props => <div {...props} className={trackClass} />}
                renderThumbVertical={props => <div {...props} className={thumbClass} />}
                universal
            >
                {this.props.children}
            </Scrollbars>
        );
    }
}
